var useLocationPathname = function () {
    if (typeof window === 'undefined')
        return '';
    return window.location.pathname;
};

export { useLocationPathname as default };
//# sourceMappingURL=useLocationPathname.esm.js.map
